import e from "@dialpad/dialtone-tokens/layered/themes/tokens-cactus-bloom-colors.css?inline";
//#region themes/cactus-bloom.js
var t = {
	brand: {
		css: e,
		name: "cactus-bloom"
	},
	material: { name: "sandstone" }
};
//#endregion
export { t as default };
